import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import styles from '../../styles/popup.module.css';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titlePop: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '1.25rem',
        }
    }
}));


function Popup(props) {
    const classes = useStyles();
    const [openPop, setOpenPop] = useState(props.openPop);
    const [titlePop, setTitlePop] = useState(props.title);

    const handleClosePop = () => {
        props.handleClosePop();
    }

    useEffect(() => {
        setOpenPop(props.openPop);
    }, [props.openPop]);

    useEffect(() => {
        setTitlePop(props.title);
    }, [props.title]);

    return (
        <Dialog style={{zIndex: '10000'}} fullScreen open={openPop} onClose={handleClosePop} TransitionComponent={Transition}>
            <div>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClosePop} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.titlePop}>
                            {titlePop}
                        </Typography>
                    </Toolbar>
                </AppBar>
            </div>

            <div>
                {props.children}
            </div>
        </Dialog>
    );
}

export default withNamespaces(['popup'], { wait: true })(Popup);